import { CheckIcon } from '../../icons/CheckIcon';
import { CloseIcon } from '../../icons/CloseIcon';
import { ErrorIcon } from '../../icons/ErrorIcon';
import { InfoIcon } from '../../icons/InfoIcon';
import { XCircleIcon } from '../../icons/XCircleIcon';
import { Divider, DismissButton, IconFrame, Label, Message, Wrapper } from './Toast.styles';
import type { ToastProps, ToastTone } from './Toast.types';

const ALERT_TONES: ToastTone[] = ['warning', 'danger'];

export const isAlertTone = (tone: ToastTone) => ALERT_TONES.includes(tone);

function renderToneIcon(tone: ToastTone) {
  switch (tone) {
    case 'positive':
      return <CheckIcon size={24} />;
    case 'info':
      return <InfoIcon size={20} />;
    case 'warning':
      return <ErrorIcon size={20} />;
    case 'danger':
      return <XCircleIcon size={20} />;
    default:
      return null;
  }
}

export function Toast({
  children,
  tone = 'neutral',
  label,
  onDismiss,
  dismissLabel = 'Dismiss',
  className,
}: ToastProps) {
  const icon = renderToneIcon(tone);

  return (
    <Wrapper
      className={className}
      data-tone={tone}
      data-testid="toast"
      role={isAlertTone(tone) ? 'alert' : 'status'}
    >
      {icon && <IconFrame aria-hidden="true">{icon}</IconFrame>}

      <Message>{children}</Message>

      {label && <Label>{label}</Label>}

      {onDismiss && (
        <>
          <Divider aria-hidden="true" />
          <DismissButton type="button" onClick={onDismiss} aria-label={dismissLabel}>
            <CloseIcon size={10} />
          </DismissButton>
        </>
      )}
    </Wrapper>
  );
}
